import axios from "axios";

export const loadAllSiteAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&page=${
        payload.currentPage
      }&countries=[${payload.selectedCountries}]&admins=[${
        payload.salesman
      }]&statusesId=[${payload.statusFilters}]&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&isActive=${payload.status}&${payload.objectType}=${
        payload.objectId
      }&orderColumn=${payload.sort ? payload.sort.column : "id"}&search=${
        payload.search ?? ""
      }`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleSiteAPI = (payload) => {
  return axios
    .get(`/sites/${payload.siteId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
